(() => {
  // Texte in der Sprache der Seite: window.cmT.editorial_search aus snippets/cm-x-js-texts
  // (Texte in snippets/cm-xt-js, Abschnitt editorial_search). Fehlt cmT oder ein Schlüssel, gilt der deutsche Text hier.
  const cmTexts = (window.cmT && window.cmT.editorial_search) || {};
  const tx = (key, de) => {
    const own = cmTexts[key];
    return typeof own === 'string' && own && !/^(translation missing|\[text fehlt)/i.test(own) ? own : de;
  };
  const cache = new Map();
  // Englisch (05.10.2026): /en lädt cm-editorial-index-en.json (Titel/Texte aus den Shopify-Übersetzungen); die Links
  // bekommen das Sprach-Präfix (Shopify.routes.root = „/en/“), auf Deutsch bleibt die Adresse wie im Index.
  const localUrl = url => ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, '') + url;
  const normalize = value => String(value).toLowerCase().replace(/ä|ae/g, 'a').replace(/ö|oe/g, 'o').replace(/ü|ue/g, 'u').replace(/ß/g, 'ss').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  async function search(url, query, limit = 4) {
    if (!url || query.trim().length < 2) return [];
    if (!cache.has(url)) {
      const promise = fetch(url, {credentials: 'omit', signal: AbortSignal.timeout(5000)})
        .then(response => { if (!response.ok) throw new Error('Editorial search unavailable'); return response.json(); })
        .then(items => items.filter(item => /^\/pages\/[a-z0-9-]+$/.test(item.url)).map(item => ({...item, heading: normalize(item.title), body: normalize(item.text)})))
        .catch(error => { cache.delete(url); throw error; });
      cache.set(url, promise);
    }
    const terms = normalize(query).split(/\s+/).filter(Boolean);
    const entries = await cache.get(url);
    return entries.map(item => {
      const all = item.heading + ' ' + item.body;
      if (!terms.every(term => all.includes(term))) return null;
      const score = terms.reduce((sum, term) => sum + (item.heading.includes(term) ? 12 : 1), 0) + (item.heading.includes(normalize(query)) ? 20 : 0);
      let excerpt = item.description;
      const position = item.body.indexOf(terms[0]);
      if (position >= 0) {
        const start = Math.max(0, item.text.lastIndexOf(' ', Math.max(0, position - 55)));
        excerpt = (start > 0 ? '… ' : '') + item.text.slice(start, start + 185).trim() + (start + 185 < item.text.length ? ' …' : '');
      }
      return {...item, score, excerpt};
    }).filter(Boolean).sort((a,b) => b.score - a.score || a.title.localeCompare(b.title, 'de')).slice(0, limit);
  }
  function option(item) {
    const result = document.createElement('div');
    result.className = 'cm-search-option'; result.setAttribute('role', 'option'); result.setAttribute('aria-selected', 'false');
    const link = document.createElement('a'); link.href = localUrl(item.url); link.tabIndex = -1;
    const span = document.createElement('span'); const title = document.createElement('strong'); const excerpt = document.createElement('small');
    title.textContent = item.title; excerpt.textContent = item.excerpt; span.append(title, excerpt); link.append(span); result.append(link);
    return result;
  }
  window.cmEditorialSearch = {search, option};
  class EditorialResults extends HTMLElement {
    async connectedCallback() {
      if (this.started) return;
      this.started = true;
      try {
        const matches = await search(this.dataset.index, this.dataset.query || '', 100);
        if (!this.isConnected) return;
        const existing = new Set([...document.querySelectorAll('.cm-search-page-card h3 a')].map(a => new URL(a.href).pathname));
        const additional = matches.filter(item => !existing.has(localUrl(item.url)));
        if (!additional.length) return;
        // Unter „Alles“ stehen die Seiten nach den Produkten und nur die besten (data-limit), der Rest unter
        // „Service & Wissen“ (data-more-url) — Drehbuch 0.2 V-5, 30.09.2026.
        const limit = Number(this.dataset.limit) > 0 ? Number(this.dataset.limit) : additional.length;
        const shown = additional.slice(0, limit);
        const title = document.createElement('h2'); title.textContent = tx('title_html', 'Passende Seiten & Beratung');
        const list = document.createElement('div'); list.className = 'cm-editorial-results-grid';
        shown.forEach(item => {
          const card = document.createElement('article'); card.className = 'cm-search-page-card';
          const heading = document.createElement('h3'); const link = document.createElement('a'); link.href = localUrl(item.url); link.textContent = item.title;
          const excerpt = document.createElement('p'); excerpt.textContent = item.excerpt;
          heading.append(link); card.append(heading, excerpt); list.append(card);
        });
        const parts = [title, list];
        if (additional.length > shown.length && this.dataset.moreUrl) {
          const more = document.createElement('a'); more.className = 'cm-text-link cm-editorial-more'; more.href = this.dataset.moreUrl;
          more.style.cssText = 'display:inline-block;margin-top:18px;color:var(--cm-blue);text-decoration:none';
          more.textContent = tx('more_html', 'Alle passenden Seiten unter „Service & Wissen“ →');
          parts.push(more);
        }
        this.replaceChildren(...parts); this.hidden = false;
        this.closest('.template-search')?.classList.remove('template-search--empty');
        document.querySelector('.cm-search-empty')?.setAttribute('hidden', '');
      } catch (_) { /* Native Shopify search remains available. */ }
    }
  }
  if (!customElements.get('cm-editorial-results')) customElements.define('cm-editorial-results', EditorialResults);
})();
